<template>
  <div class="t_box timer_box1">
    <div
      id="to_play_meteo"
      src="image/start.png"
      style="background-image: url(image/start.png)"
      t="1619402630127"
      fill="#00d3e7"
      class="svg"
      viewBox="0 0 1270 1024"
      version="1.1"
      p-id="10152"
      width="26"
      height="30"
    >
      <!-- <path
        d="M1156.347527 0.000028H113.828271A113.757261 113.757261 0 0 0 0.000001 113.785693V910.214335a113.771463 113.771463 0 0 0 113.82827 113.743059h1042.519256a113.771463 113.771463 0 0 0 113.771463-113.785664V113.785693A113.757261 113.757261 0 0 0 1156.347527 0.000028z m-764.857807 833.509817V190.490183l556.856703 321.50273z m0 0"
        p-id="10153"
      ></path> -->
    </div>

    <div class="i_line">
      <div class="i_avbl" id="timerControlDiv">
        <div class="i_played"></div>
      </div>
    </div>
    <div class="i_drag" t=""></div>

    <div class="i_tline">
      <span class="" name="">0</span>
    </div>
    <span id="gap"></span>
    <div id="tooltip2"></div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.t_box {
  display: none;
  z-index: 2;
  height: 49px;
  width: 80%;
  position: absolute;
  left: 2%;
  bottom: 10px;
  left: 180px;
}

.t_box > .svg {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 8px;
  left: -32px;
  cursor: pointer;
  background: no-repeat;
  background-size: 100% 100%;
}

.i_line {
  margin: 12px 0px 0px 0px;
  height: 6px;
  cursor: pointer;
  width: 100%;
}

.i_drag {
  position: absolute;
  top: -20px;
  left: 43px;
  background: #4dccca;
  font-size: 12px;
  line-height: 25px;
  width: 120px;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}

.i_avbl {
  height: 9px;
  width: 100%;
  background: #000000;
  opacity: 0.7;
  border-radius: 5px;
}

.i_played {
  float: left;
  width: 0px;
  height: 9px;
  background: #00fffc;
  border-radius: 5px;
}

.i_tline {
  display: flex;
  width: 100%;
  margin: 4px 0px 0px 0px;
  color: #fff;
  font-size: 13px;
  text-align: center;
}

.i_drag::before {
  top: 100%;
  left: 40px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  border-top-color: #4dccca;
  border-width: 6px;
}

#tooltip2 {
  position: absolute;
  bottom: 43px;
  background: rgb(78, 77, 72);
  font-size: 12px;
  line-height: 25px;
  width: 150px;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  z-index: 3;
}
#tooltip2::before {
  top: 100%;
  left: 20px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  border-top-color: rgb(78, 77, 72);
  border-width: 6px;
  z-index: 3;
}
</style>